import { render, staticRenderFns } from "./InfoForm.vue?vue&type=template&id=1031b646&scoped=true&"
import script from "./InfoForm.vue?vue&type=script&lang=js&"
export * from "./InfoForm.vue?vue&type=script&lang=js&"
import style0 from "./InfoForm.vue?vue&type=style&index=0&id=1031b646&prod&lang=scss&scoped=true&"
import style1 from "./InfoForm.vue?vue&type=style&index=1&id=1031b646&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031b646",
  null
  
)

export default component.exports